import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { Pessoa } from './models/pessoa';
import { Endereco } from './models/endereco';
import { Atributo } from './models/atributo';
import { filtroDashboard } from '../dashboard/models/dashboard';
import { PessoaCombo } from '../usuario/models/usuario';

@Injectable({
    providedIn: 'root'
  })

export class PessoaService{
    
    private environmentUrl: string = '';    

    constructor(private httpClient: HttpClient) { this.environmentUrl = environment.ApiCore; }
    
    getPessoa() : Observable<Pessoa[]>{   
        let url = this.environmentUrl+"/Pessoa/";        
        return this.httpClient.get<Pessoa[]>(url);
    }

    getPessoaComboLista(query: string) : Observable<PessoaCombo[]>{   
        let url = this.environmentUrl+"/Pessoa/ListaCombo/"+query;        
        return this.httpClient.get<PessoaCombo[]>(url);
    }

    getPessoaCombo(idPessoa: number) : Observable<PessoaCombo>{   
        let url = this.environmentUrl+"/Pessoa/Combo/"+idPessoa;        
        return this.httpClient.get<PessoaCombo>(url);
    }

    getPessoaEndereco(idPessoa: string) : Observable<Endereco[]>{   
        let url = this.environmentUrl+"/Endereco/Pessoa/"+idPessoa;        
        return this.httpClient.get<Endereco[]>(url);
    }
    
    getPessoaAtributo(idPessoa: string) : Observable<Atributo[]>{  
        console.log('atrb '+idPessoa); 
        let url = this.environmentUrl+"/Pessoa/"+idPessoa+"/Atributo";        
        return this.httpClient.get<Atributo[]>(url);
    }

    getAtributos() : Observable<Atributo[]>{  
        console.log('atrb '); 
        let url = this.environmentUrl+"/Atributo";        
        return this.httpClient.get<Atributo[]>(url);
    }

    delAtributo(idAtributo: number) {
        return this.httpClient.delete(this.environmentUrl + "/Atributo/" + idAtributo);
    }

    addAtributo(atributo: Atributo) {
        return this.httpClient.post(this.environmentUrl + "/Atributo", atributo);
    }

    updAtributo(atributo: Atributo) {
        return this.httpClient.put(this.environmentUrl + "/Atributo", atributo);
    }
    

    getPessoaByCPF(cpf: string) : Observable<Pessoa>{  
        console.log('atrb '+cpf); 
        let url = this.environmentUrl+"/Pessoa/cpf/"+cpf;        
        return this.httpClient.get<Pessoa>(url);
    }
    getPessoaByMat(mat: string) : Observable<Pessoa>{  
        console.log('atrb '+mat); 
        let url = this.environmentUrl+"/Pessoa/mat/"+mat;        
        return this.httpClient.get<Pessoa>(url);
    }

    getPessoasDashboard(idEvento: string) {
        return this.httpClient.get<filtroDashboard[]>(this.environmentUrl + "/pessoa/FiltroDashboard/" + idEvento);
    }
}

  
  